import {Location} from 'history'

import {LocationState} from './interface'

export const initialLocation: Location = {
    key: '',
    hash: window.location.hash,
    pathname: window.location.pathname,
    search: window.location.search,
    state: {},
}

/** LocationState 타입에 부합하는지 비교하기 위한 sample 값 */
export const sampleLocationState: Required<LocationState> = {
    fullScreenDialogId: '',
    deliveryFullScreenDialogId: '',
    fullScreenIframeSrc: {
        url: '',
        restoreOnRefresh: false,
    },
    deliveryManagerScene: 'SEARCH',
    historyCountFromBase: 0,
    sheetId: '',
    fullScreenId: '',
    shouldAuthenticationCheck: false,
}

/** LocationState 타입에 맞게 작성된 객체, 필드 타입이 optional이라면 undefined */
export const defaultLocationState: LocationState = {
    fullScreenIframeSrc: {
        url: '',
        restoreOnRefresh: false,
    },
}
